import type { Undefinable } from "@core/domain/types/undefinable.type.ts";
import * as z from "zod";

export const PaginatedDtoSchema = z.object({
    count: z.number().nonnegative(),
    current: z.number().nonnegative(),
    next: z.number().nonnegative().nullable(),
    pages: z.number().nonnegative(),
    per_page: z.number().nonnegative(),
    previous: z.number().nonnegative().nullable(),
});

export type PaginatedDto = z.output<typeof PaginatedDtoSchema>;

export interface PaginatedQuery {
    page: number;
    page_size: Undefinable<number>;
}
